import { ConfigToSendInterface } from '@greenkub-fronts/shared/interface';
import { CustomerConfigurationGateway } from './customer-configuration-gateway.interface';

const baseUrl = 'customer/configurations';
export class HttpCustomerConfigurationGateway
  implements CustomerConfigurationGateway
{
  private baseUrl = baseUrl;

  patchCustomerConfigurations(args: {
    projectId: string;
    configurations: ConfigToSendInterface[];
  }) {
    return {
      url: `${baseUrl}/${args.projectId}`,
      method: 'PATCH',
      data: { configurations: args.configurations },
    };
  }
}
